export const NO_DETAILS = 'No details to show';
export const DEFAULT_PAGE_SIZE = 8;
export const DEFAULT_PAGE = 1;
export const MAX_EMAIL_COUNT = 9999;

export const LINE_ITEMS_TABLE_HEADER_NAMES = {
  DETAILS: 'Details',
  SUBSCRIPTION: 'Subscription',
  CUSTOMER_CONTACTS: 'Customer contacts',
  BILLING_PERIOD: 'Billing period',
  USAGE: 'Usage',
  AMOUNT: 'Amount',
  LIST_PRICE: 'List price',
  PARTNER_MARGIN: 'Partner discount',
  DISCOUNTS_APPLIED: 'Discounts applied',
  AMOUNT_EXCL_TAX: 'Amount excl. tax',
  AMOUNT_INCL_TAX: 'Amount incl. tax',
  TAX_RATE: 'Tax rate %',
  ORGANIZATION: 'Organization',
  SITE: 'Site',
};
